export default "__VITE_ASSET__DpHMZtly__"